import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import './custom.scss';
import App from './App';

const root = document.getElementById('root');
const appRoot = createRoot(root!);

appRoot.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
